(function () {
  if (!window.rfGetCountry) {
    window.rfGetCountry = (function () {
      var promise = null;
      function readSession(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
      function writeSession(key, value) { try { sessionStorage.setItem(key, value); } catch (e) {} }
      function readCookie(name) {
        try {
          var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
          return match ? decodeURIComponent(match[1]) : null;
        } catch (e) { return null; }
      }
      function isPreview(designMode) {
        if (designMode === 'true') return true;
        if (window.Shopify && window.Shopify.designMode) return true;
        var theme = window.Shopify && window.Shopify.theme;
        if (theme && theme.role && theme.role !== 'main') return true;
        return /[?&]preview_theme_id=/.test(window.location.search);
      }
      function rememberSelectorChoice(event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var form = target.closest('form[action*="/localization"], localization-form, [data-localization-form]');
        if (!form) return;
        setTimeout(function () {
          var input = form.querySelector('[name="country_code"]');
          var value = (input && input.value) || (target.dataset && (target.dataset.value || target.dataset.countryCode)) || target.value || '';
          value = String(value).toUpperCase();
          if (/^[A-Z]{2}$/.test(value)) writeSession('rfChosenCountry', value);
        }, 0);
      }
      document.addEventListener('click', rememberSelectorChoice, true);
      document.addEventListener('change', rememberSelectorChoice, true);
      document.addEventListener('submit', rememberSelectorChoice, true);

      return function (liquidCountry, designMode) {
        if (promise) return promise;
        liquidCountry = String(liquidCountry || '').toUpperCase();
        if (!/^[A-Z]{2}$/.test(liquidCountry)) liquidCountry = '';
        var lastLiquid = readSession('rfLastLiquidCountry');
        if (liquidCountry) writeSession('rfLastLiquidCountry', liquidCountry);
        if (liquidCountry && isPreview(designMode)) return (promise = Promise.resolve(liquidCountry));
        var cookieCountry = String(readCookie('localization') || '').toUpperCase();
        if (/^[A-Z]{2}$/.test(cookieCountry)) return (promise = Promise.resolve(liquidCountry || cookieCountry));
        var chosen = String(readSession('rfChosenCountry') || '').toUpperCase();
        if (/^[A-Z]{2}$/.test(chosen)) return (promise = Promise.resolve(liquidCountry || chosen));
        if (liquidCountry && lastLiquid && lastLiquid !== liquidCountry) {
          writeSession('rfChosenCountry', liquidCountry);
          return (promise = Promise.resolve(liquidCountry));
        }
        var cached = readSession('rfDetectedCountry');
        var lookup = cached !== null
          ? Promise.resolve(cached === 'none' ? null : cached)
          : fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
              .then(function (res) { return res.ok ? res.json() : null; })
              .then(function (data) {
                var handle = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
                var code = handle ? String(handle).toUpperCase() : null;
                writeSession('rfDetectedCountry', code || 'none');
                return code;
              })
              .catch(function () { return null; });
        promise = lookup
          .then(function (detected) { return detected || liquidCountry || null; })
          .catch(function () { return liquidCountry || null; });
        return promise;
      };
    })();
  }

  if (!window.rfPolicyInit) {
    window.rfPolicyInit = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-rf-policy-open]');
      if (trigger) {
        var dialog = document.querySelector('dialog[data-rf-policy]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        if (dialog.open) return;
        if (dialog.parentNode !== document.body) document.body.appendChild(dialog);
        try { dialog.showModal(); } catch (e) { return; }
        document.documentElement.classList.add('rf-policy-lock');
        var body = dialog.querySelector('.rf-policy__body');
        if (body) body.scrollTop = 0;
        return;
      }
      var closeBtn = event.target.closest && event.target.closest('[data-rf-policy-close]');
      if (closeBtn) {
        var d = closeBtn.closest('dialog');
        if (d && d.open) d.close();
        return;
      }
      var target = event.target;
      if (target && target.matches && target.matches('dialog[data-rf-policy]')) {
        var rect = target.getBoundingClientRect();
        var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) target.close();
      }
    });
    document.addEventListener('close', function (event) {
      if (event.target && event.target.matches && event.target.matches('dialog[data-rf-policy]')) {
        document.documentElement.classList.remove('rf-policy-lock');
      }
    }, true);
  }

  if (!window.rfCartWatch) {
    window.rfCartWatch = true;
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    var notifyCart = function () {
      setTimeout(function () { document.dispatchEvent(new CustomEvent('rf:cart-changed')); }, 60);
    };
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && (input.url || input.href)) || '';
        var result = origFetch.apply(this, arguments);
        if (CART_RE.test(String(url)) && result && result.then) result.then(notifyCart, notifyCart);
        return result;
      };
    }
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (CART_RE.test(String(url))) this.addEventListener('loadend', notifyCart);
      return origOpen.apply(this, arguments);
    };
  }

  if (customElements.get('rf-shipping')) return;

  var WEEKDAYS = {
    de: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  };
  var WEEKDAYS_LONG = {
    de: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  };
  var MONTHS = {
    de: ['Jan', 'Feb', 'März', 'Apr', 'Mai', 'Juni', 'Juli', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  };

  /* logos are fetched once per page and reused by every block instance */
  var LOGO_PRELOADED = {};
  function preloadLogo(src) {
    /* No early download: the logos are lazy images now (see the render below). */
    if (!src || LOGO_PRELOADED[src]) return;
    LOGO_PRELOADED[src] = true;
  }

  /* ---------- pure helpers ---------- */

  function berlinNow(tz) {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)),
      minutes: (+parts.hour) * 60 + (+parts.minute),
      seconds: +parts.second
    };
  }

  function iso(date) { return date.toISOString().slice(0, 10); }
  function addDays(date, n) { return new Date(date.getTime() + n * 86400000); }

  function isShipDay(date, data) {
    return data.shipDays.indexOf(date.getUTCDay()) !== -1 && data.holidays.indexOf(iso(date)) === -1;
  }

  function nextShipDay(date, data) {
    var d = date;
    for (var i = 0; i < 30; i++) {
      d = addDays(d, 1);
      if (isShipDay(d, data)) return d;
    }
    return d;
  }

  function shipInfo(data) {
    var now = berlinNow(data.tz || 'Europe/Berlin');
    var cut = String(data.cutoff || '14:30').split(':');
    var cutMin = (+cut[0]) * 60 + (+cut[1] || 0);
    var today = now.date;
    var shipsToday = isShipDay(today, data) && now.minutes < cutMin;
    var ship = shipsToday ? today : nextShipDay(today, data);
    for (var p = 0; p < (data.processing || 0); p++) ship = nextShipDay(ship, data);
    var left = shipsToday ? (cutMin - now.minutes) * 60 - now.seconds : 0;
    return { today: today, ship: ship, shipsToday: shipsToday && !data.processing, secondsLeft: left };
  }

  function addTransitDays(date, n, holidays) {
    var d = date;
    var added = 0;
    while (added < n) {
      d = addDays(d, 1);
      var wd = d.getUTCDay();
      if (wd !== 0 && wd !== 6 && (!holidays || holidays.indexOf(iso(d)) === -1)) added++;
    }
    return d;
  }

  function formatDay(date, lang, withMonth) {
    var wd = WEEKDAYS[lang][date.getUTCDay()];
    var day = date.getUTCDate();
    var mon = MONTHS[lang][date.getUTCMonth()];
    if (lang === 'de') return wd + ' ' + day + '.' + (withMonth === false ? '' : ' ' + mon);
    return wd + ' ' + day + (withMonth === false ? '' : ' ' + mon);
  }

  function formatRange(a, b, lang) {
    if (iso(a) === iso(b)) return formatDay(a, lang);
    var sameMonth = a.getUTCMonth() === b.getUTCMonth();
    /* No en dash in customer copy (7 Oct 2026): 'bis' / 'to'. */
    return formatDay(a, lang, !sameMonth) + (lang === 'de' ? ' bis ' : ' to ') + formatDay(b, lang);
  }

  function quote(country, grams, subtotalEurCents) {
    var list = [];
    Object.keys(country.s).forEach(function (name) {
      var svc = country.s[name];
      var price = null;
      svc.w.forEach(function (r) {
        if (grams >= r[0] && grams <= r[1]) price = price === null ? r[2] : Math.min(price, r[2]);
      });
      svc.v.forEach(function (r) {
        if (subtotalEurCents >= r[0] * 100) price = price === null ? r[1] : Math.min(price, r[1]);
      });
      if (price !== null) list.push({ name: name, cents: price, days: svc.d });
    });
    list.sort(function (x, y) { return x.cents - y.cents || x.days[0] - y.days[0]; });
    return list;
  }

  /* A shipping rate (euro cents) in the shopper's currency, the way checkout charges it (29 Oct 2026). Shopify
     converts at the market rate and then rounds converted prices AND shipping rates up to the currency's usual
     step (Markets > price rounding, on for every non-euro market here). Checked against the Admin API
     (contextualPricing) for every non-euro currency we sell in and against the checkout: CHF, GBP, DKK, SEK,
     PLN, CZK and RON round up to whole units, HUF to whole hundreds (LI: EUR 12.90 -> CHF 13.00 in checkout,
     where the plain conversion showed CHF 12.14). Other currencies keep the plain conversion. */
  var ROUND_STEP = { CHF: 1, GBP: 1, DKK: 1, SEK: 1, PLN: 1, CZK: 1, RON: 1, HUF: 100 };
  function localCents(eurCents, rate, currency) {
    rate = parseFloat(rate) || 1;
    if (!eurCents || rate === 1) return Math.round(eurCents || 0);
    var cur = currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var step = ROUND_STEP[cur];
    var units = eurCents * rate / 100;
    if (!step) return Math.round(units * 100);
    return Math.ceil(units / step - 1e-9) * step * 100;
  }

  window.rfShipCore = { quote: quote, shipInfo: shipInfo, addTransitDays: addTransitDays, formatRange: formatRange, isShipDay: isShipDay, nextShipDay: nextShipDay, localCents: localCents };

  function formatMoneyShort(cents, sample) {
    if (cents % 100 === 0) {
      var withDecimals = sample.match(/123(\D)45/);
      if (withDecimals) return sample.replace(withDecimals[0], String(Math.round(cents / 100)));
    }
    return formatMoney(cents, sample);
  }

  function formatMoney(cents, sample) {
    var withDecimals = sample.match(/123(\D)45/);
    if (withDecimals) {
      var amount = (cents / 100).toFixed(2).replace('.', withDecimals[1]);
      return sample.replace(withDecimals[0], amount);
    }
    if (/123/.test(sample)) return sample.replace('123', String(Math.round(cents / 100)));
    return (cents / 100).toFixed(2);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- custom element ---------- */

  class RfShipping extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.lang = this.dataset.lang === 'de' ? 'de' : 'en';
      try { this.data = JSON.parse(this.querySelector('[data-rf-ship-data]').textContent); } catch (e) { this.data = null; }
      try { this.variants = JSON.parse(this.querySelector('[data-rf-variants]').textContent); } catch (e) { this.variants = {}; }
      if (!this.data) return;

      this.cart = { items: [] };
      this.country = null;
      this.signature = '';
      this.rowCache = {};

      /* fetch every carrier logo up front so no row ever waits for an image */
      if (this.data.logos) {
        var logos = this.data.logos;
        Object.keys(logos).forEach(function (key) { preloadLogo(logos[key]); });
      }

      var self = this;
      this.cartSeq = 0;
      this.onCartUpdate = function () { self.loadCart(); };
      this.onPageShow = function () { self.loadCart(); };
      this.onVisible = function () { if (document.visibilityState === 'visible') self.loadCart(); };
      document.addEventListener('rf:cart-changed', this.onCartUpdate);
      document.addEventListener('cart:update', this.onCartUpdate);
      document.addEventListener('cart:refresh', this.onCartUpdate);
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('visibilitychange', this.onVisible);

      var change = this.querySelector('[data-rf-change]');
      if (change) change.addEventListener('click', function () { self.openLocalization(); });

      // Pagespeed V4: safety-net poll, 1x per second and paused in background tabs (events handle instant updates)
      this.poll = setInterval(function () { if (!document.hidden) self.check(); }, 1000);
      this.tick = setInterval(function () { self.renderEta(); }, 30000);

      window.rfGetCountry(this.dataset.country, this.dataset.designMode)
        .then(function (code) { self.setCountry(code || self.dataset.country); })
        .catch(function () { self.setCountry(self.dataset.country); });

      this.loadCart();
    }

    disconnectedCallback() {
      clearInterval(this.poll);
      clearInterval(this.tick);
      document.removeEventListener('rf:cart-changed', this.onCartUpdate);
      document.removeEventListener('cart:update', this.onCartUpdate);
      document.removeEventListener('cart:refresh', this.onCartUpdate);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('visibilitychange', this.onVisible);
    }

    setCountry(code) {
      code = String(code || '').toUpperCase();
      this.country = code;
      this.countryData = this.data.countries[code] || null;
      var flag = this.querySelector('[data-rf-flag]');
      if (flag && /^[A-Z]{2}$/.test(code)) {
        flag.style.backgroundImage = 'url(https://cdn.shopify.com/static/images/flags/' + code.toLowerCase() + '.svg?width=44)';
      }
      var title = this.querySelector('[data-rf-title]');
      if (title && this.countryData) title.textContent = this.lang === 'de' ? this.countryData.tde : this.countryData.ten;
      this.signature = '';
      this.check();
    }

    loadCart() {
      if (this.dataset.includeCart !== 'true') return;
      var self = this;
      var seq = ++this.cartSeq;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js?t=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || seq !== self.cartSeq) return;
          self.cart = cart;
          self.signature = '';
          self.check();
        })
        .catch(function () {});
    }

    get qty() {
      var input = this.section && this.section.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
      return Math.max(1, parseInt(input && input.value, 10) || 1);
    }

    get variantId() {
      var input = this.section && this.section.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] [name="id"]');
      if (input && this.variants[input.value]) return String(input.value);
      try {
        var id = new URL(window.location.href).searchParams.get('variant');
        if (id && this.variants[id]) return String(id);
      } catch (e) {}
      return String(this.dataset.variantId);
    }

    get tierPercents() {
      var tiers = this.section && this.section.querySelector('rf-volume-tiers');
      var p2 = parseInt((tiers && tiers.dataset.pct2) || this.dataset.pct2, 10) || 0;
      var p3 = parseInt((tiers && tiers.dataset.pct3) || this.dataset.pct3, 10) || 0;
      return [p2, p3];
    }

    get rate() {
      var c = window.Shopify && window.Shopify.currency;
      if (c && c.active && c.active !== this.dataset.shopCurrency && parseFloat(c.rate) > 0) return parseFloat(c.rate);
      return 1;
    }

    itemGrams(grams, handle) {
      grams = parseInt(grams, 10) || 0;
      if (grams === 0 && this.data.weights[handle]) return this.data.weights[handle];
      return grams;
    }

    /* Units of this product a shopper may have in one order. 0 means no cap.
       Enforced server side, so a quote that ignores it is simply wrong. */
    get maxPerOrder() {
      return parseInt(this.dataset.maxPerOrder, 10) || 0;
    }

    /* How many units can still be added on top of what the cart holds. */
    addableQty(qty, inCart) {
      var max = this.maxPerOrder;
      if (max <= 0) return qty;
      var room = max - inCart;
      if (room < 0) room = 0;
      return Math.min(qty, room);
    }

    /* Model the cart's discount codes onto a gross subtotal.
       Shopify evaluates price based shipping rates AFTER discounts, verified
       against cart/shipping_rates.json: the same cart quoted 0.00 without a
       code and 10.90 with a 10 percent code. A percentage code that targets
       the whole order scales with it, so it applies to extra units too.
       Anything else (fixed amount, or a code aimed at specific products) is
       taken as the flat amount Shopify already allocated, which does not grow. */
    applyCartDiscount(gross) {
      var apps = (this.cart && this.cart.cart_level_discount_applications) || [];
      if (!apps.length) return gross;
      var pct = 0;
      var flat = 0;
      apps.forEach(function (a) {
        if (a.value_type === 'percentage' && a.target_selection === 'all') {
          pct += parseFloat(a.value) || 0;
        } else {
          flat += a.total_allocated_amount || 0;
        }
      });
      if (pct > 100) pct = 100;
      var out = Math.round(gross * (100 - pct) / 100) - flat;
      return out > 0 ? out : 0;
    }

    /* 24 Oct 2026: change in cents when the other products' subscription lines move to plan tier aboPct
       (5 / 10 in the 95 - x formula). Their current plan price is in selling_plan_allocation.price; the Mix Box
       sale (window.rfSalePct) comes on top of the plan price on the first delivery, cut to whole cents. */
    aboRetier(productId, aboPct) {
      var items = (this.dataset.includeCart === 'true' && this.cart && this.cart.items) || [];
      var delta = 0;
      items.forEach(function (item) {
        var sa = item.selling_plan_allocation;
        if (!sa || item.requires_shipping === false || String(item.product_id) === productId) return;
        var base = sa.compare_at_price || item.original_price;
        var sp = window.rfSalePct ? window.rfSalePct(String(item.product_id)) : 0;
        var withSale = function (plan) { return sp ? plan - Math.floor((plan * sp) / 100) : plan; };
        var now = withSale(sa.price);
        var next = withSale(Math.round((base * (95 - aboPct)) / 100));
        delta += (next - now) * item.quantity;
      });
      return delta;
    }

    /* Totals for the cart plus the selected quantity of this product, in presentment cents */
    scenario(qty) {
      var v = this.variants[this.variantId] || [0, 0];
      var price = v[0];
      var grams = this.itemGrams(v[1], this.dataset.handle);
      var productId = String(this.dataset.productId);
      var useCart = this.dataset.includeCart === 'true';

      var otherSubtotal = 0;
      var otherGrams = 0;
      var cartQtyThis = 0;
      var cartOrigThis = 0;
      var cartGramsThis = 0;
      var linesThis = [];

      if (useCart && this.cart && this.cart.items) {
        var self = this;
        this.cart.items.forEach(function (item) {
          if (item.requires_shipping === false) return;
          var g = self.itemGrams(item.grams, item.handle) * item.quantity;
          if (String(item.product_id) === productId) {
            cartQtyThis += item.quantity;
            cartOrigThis += item.original_line_price;
            cartGramsThis += g;
            /* Abo lines: the box price before the plan, the plan is worked out again below. */
            var sa = item.selling_plan_allocation;
            linesThis.push([(sa && sa.compare_at_price) || item.original_price, item.quantity]);
          } else {
            otherSubtotal += item.final_line_price;
            otherGrams += g;
          }
        });
      }

      /* A product already at its per-order cap cannot be added again, so the
         scenario is the cart as it stands. Quoting cart plus one more here
         promised free shipping that checkout would refuse. */
      var addQty = this.addableQty(qty, cartQtyThis);

      var totalQtyThis = cartQtyThis + addQty;
      var pct = 0;
      if (this.dataset.volume === 'true') {
        var tp = this.tierPercents;
        pct = totalQtyThis >= 3 ? tp[1] : totalQtyThis === 2 ? tp[0] : 0;
      }
      /* Abo on (snippets/rf-abo.liquid) and this product can be subscribed: the boxes added
         here get the plan price (5% off, rounded like Shopify). Duo / Trio come on top. Shopify
         cuts the discount per box to whole cents (rounded down), so the sum runs per box. */
      var abo = window.rfAboState && window.rfAboState.on &&
        this.section && this.section.querySelector('rf-abo-toggle[data-context="pdp"]');
      /* 24 Oct 2026: on the Abo every box on the subscription counts for the tier, of any product, like in the
         cart (rf-abo.js tierPct(ABO_COUNT + qty)): the boxes already on it (rf-abo.js count) plus the ones
         added here. Other products' subscription lines move to that tier too, so they are priced again. */
      var aboPct = pct;
      if (abo) {
        var atp = this.tierPercents;
        var aboBoxes = (Number(window.rfAboState.count) || 0) + addQty;
        aboPct = aboBoxes >= 3 ? atp[1] : aboBoxes === 2 ? atp[0] : 0;
        otherSubtotal += this.aboRetier(productId, aboPct);
      }
      if (addQty > 0) linesThis.push([price, addQty]);
      var thisFinal = 0;
      linesThis.forEach(function (l) {
        /* Abo: the plan price holds the whole discount (5 / 10 / 15 % by box count), rounded to
           the cent; one-time: Duo / Trio cut per box to whole cents (rounded down). */
        thisFinal += abo
          ? Math.round(l[0] * (95 - aboPct) / 100) * l[1]
          : (l[0] - Math.floor(l[0] * pct / 100)) * l[1];
      });

      var gross = otherSubtotal + thisFinal;
      var subtotal = this.applyCartDiscount(gross);

      /* Nothing added and no tier re-pricing: the cart's own discounted
         total is authoritative and rounds exactly the way checkout does,
         so the shipping box and the cart drawer bar agree to the cent. */
      var cartObj = useCart ? this.cart : null;
      if (addQty === 0 && pct === 0 && cartObj && typeof cartObj.total_price === 'number' && gross === cartObj.items_subtotal_price) {
        subtotal = cartObj.total_price;
      }

      return {
        subtotal: subtotal,
        grams: otherGrams + cartGramsThis + grams * addQty,
        cartItems: useCart && this.cart && this.cart.item_count ? this.cart.item_count : 0
      };
    }

    check() {
      if (!this.country) return;
      var sig = [this.country, this.variantId, this.qty, this.cart && this.cart.token, this.cart && this.cart.item_count, this.cart && this.cart.total_price, window.rfAboState && window.rfAboState.on].join('|');
      if (sig === this.signature) return;
      this.signature = sig;
      this.render();
    }

    money(presentmentCents) {
      return formatMoney(presentmentCents, this.dataset.moneySample || '');
    }

    moneyShort(presentmentCents) {
      return formatMoneyShort(presentmentCents, this.dataset.moneySample || '');
    }

    daysLabel(d) {
      if (d[0] === d[1]) return d[0] + ' ' + (d[0] === 1 ? this.dataset.tDay : this.dataset.tDays);
      var to = (document.documentElement.lang || '').slice(0, 2) === 'de' ? ' bis ' : ' to ';
      return d[0] + to + d[1] + ' ' + this.dataset.tDays;
    }

    /* Build a row once. The element (and its <img>) is kept alive and reused,
       so quantity changes never recreate the carrier logo. */
    buildRow(svc) {
      var carrier = this.data.carriers[svc.name] || '';
      var logoSrc = this.data.logos[carrier];

      var row = document.createElement('div');
      row.className = 'rf-sd__row';

      var cell = document.createElement('span');
      cell.className = 'rf-sd__logo-cell';
      if (logoSrc) {
        var img = document.createElement('img');
        img.className = 'rf-sd__logo rf-sd__logo--' + carrier.toLowerCase();
        img.alt = carrier;
        img.width = 500;
        img.height = 275;
        /* The rates sit below the fold; the logos load when they come near the viewport. */
        img.loading = 'lazy';
        img.decoding = 'async';
        if ('fetchPriority' in img) img.fetchPriority = 'low';
        img.src = logoSrc;
        cell.appendChild(img);
      }

      var svcEl = document.createElement('span');
      svcEl.className = 'rf-sd__svc';
      var nameEl = document.createElement('span');
      nameEl.className = 'rf-sd__svc-name';
      nameEl.textContent = svc.name;
      var daysEl = document.createElement('span');
      daysEl.className = 'rf-sd__svc-days';
      svcEl.appendChild(nameEl);
      svcEl.appendChild(daysEl);

      var priceEl = document.createElement('span');
      priceEl.className = 'rf-sd__price';

      row.appendChild(cell);
      row.appendChild(svcEl);
      row.appendChild(priceEl);

      row.rfDays = daysEl;
      row.rfPrice = priceEl;
      return row;
    }

    rowFor(svc) {
      var row = this.rowCache[svc.name];
      if (!row) {
        row = this.buildRow(svc);
        this.rowCache[svc.name] = row;
      }
      var days = this.daysLabel(svc.days);
      if (row.rfDays.textContent !== days) row.rfDays.textContent = days;

      var free = svc.cents === 0;
      var price = free ? this.dataset.tFree : this.money(localCents(svc.cents, this.rate));
      if (row.rfPrice.textContent !== price) row.rfPrice.textContent = price;
      var cls = 'rf-sd__price' + (free ? ' rf-sd__price--free' : '');
      if (row.rfPrice.className !== cls) row.rfPrice.className = cls;
      return row;
    }

    /* Sync a container to the given list, moving existing rows instead of rebuilding them */
    fillRows(container, list) {
      var self = this;
      var next = list.map(function (svc) { return self.rowFor(svc); });

      Array.prototype.slice.call(container.children).forEach(function (child) {
        if (next.indexOf(child) === -1) container.removeChild(child);
      });

      next.forEach(function (row, i) {
        if (container.children[i] !== row) {
          container.insertBefore(row, container.children[i] || null);
        }
      });
    }

    render() {
      var c = this.countryData;
      var rates = this.querySelector('[data-rf-rates]');
      var etaWrap = this.querySelector('[data-rf-eta-wrap]');
      var fallback = this.querySelector('[data-rf-fallback]');
      var duties = this.querySelector('[data-rf-duties]');

      if (!c) {
        rates.hidden = true;
        etaWrap.hidden = true;
        fallback.hidden = false;
        duties.hidden = true;
        return;
      }

      var qty = this.qty;
      var rate = this.rate;
      var sc = this.scenario(qty);
      var subtotalEur = Math.round(sc.subtotal / rate);
      var list = quote(c, sc.grams, subtotalEur);

      if (!list.length) {
        rates.hidden = true;
        etaWrap.hidden = true;
        fallback.hidden = false;
        duties.hidden = !c.dap;
        return;
      }

      fallback.hidden = true;
      rates.hidden = false;
      etaWrap.hidden = false;
      duties.hidden = !c.dap;

      this.main = list[0];
      /* The delivery estimate is the shown service's own transit time: the cheapest one, which is the free one
         once the order ships free (Raphael, 29 Oct 2026; replaces the 21 Oct span over every service). The cart
         drawer (snippets/cart-drawer.liquid) uses the same rule. */
      this.span = list[0].days;
      this.fillRows(this.querySelector('[data-rf-main]'), [list[0]]);

      /* free shipping progress */
      var progress = this.querySelector('[data-rf-progress]');
      var freeCentsEur = (c.free || 0) * 100;

      if (list[0].cents === 0) {
        progress.hidden = true;
      } else if (freeCentsEur > 0) {
        progress.hidden = false;
        var remaining = Math.max(0, freeCentsEur - subtotalEur);
        this.querySelector('[data-rf-bar]').style.width = Math.min(100, (subtotalEur / freeCentsEur) * 100) + '%';
        var rem = '<strong>' + escapeHtml(this.moneyShort(Math.round(remaining * rate))) + '</strong>';
        var thr = escapeHtml(this.moneyShort(Math.round(freeCentsEur * rate)));
        this.querySelector('[data-rf-togo]').innerHTML = this.lang === 'de'
          ? 'Noch ' + rem + ' bis zum Gratisversand (ab ' + thr + ')'
          : 'Add ' + rem + ' for free shipping (from ' + thr + ')';
      } else {
        progress.hidden = true;
      }

      /* nudge: a bigger tier that ships free */
      var nudge = this.querySelector('[data-rf-nudge]');
      nudge.hidden = true;
      if (this.dataset.showNudge === 'true' && this.dataset.volume === 'true' && list[0].cents > 0 && freeCentsEur > 0 && qty < 3) {
        var nowTotal = sc.subtotal + localCents(list[0].cents, rate);
        for (var n = qty + 1; n <= 3; n++) {
          var s2 = this.scenario(n);
          var l2 = quote(c, s2.grams, Math.round(s2.subtotal / rate));
          if (l2.length && l2[0].cents === 0) {
            var delta = s2.subtotal - nowTotal;
            var boxes = n + (this.lang === 'de' ? ' Boxen' : ' boxes');
            if (delta <= 0) {
              nudge.textContent = this.lang === 'de'
                ? 'Ab ' + boxes + ' versandkostenfrei und insgesamt ' + this.money(-delta) + ' günstiger als jetzt.'
                : 'From ' + boxes + ' shipping is free and costs ' + this.money(-delta) + ' less in total than now.';
            } else {
              nudge.textContent = this.lang === 'de'
                ? 'Ab ' + boxes + ' versandkostenfrei: nur ' + this.money(delta) + ' mehr als jetzt.'
                : 'From ' + boxes + ' shipping is free: only ' + this.money(delta) + ' more than now.';
            }
            nudge.hidden = false;
            break;
          }
        }
      }

      var cartnote = this.querySelector('[data-rf-cartnote]');
      if (sc.cartItems > 0) {
        cartnote.hidden = false;
        cartnote.textContent = this.lang === 'de' ? 'Inklusive Artikel in deinem Warenkorb' : 'Includes items in your cart';
      } else {
        cartnote.hidden = true;
      }

      /* extra services */
      var more = this.querySelector('[data-rf-more]');
      var extrasBox = this.querySelector('[data-rf-extras]');
      var extras = list.slice(1);
      if (this.dataset.showExtras === 'true' && extras.length) {
        more.hidden = false;
        var label = extras.length + ' ' + (extras.length === 1 ? this.dataset.tMoreOne : this.dataset.tMore);
        var labelEl = this.querySelector('[data-rf-more-label]');
        if (labelEl.textContent !== label) labelEl.textContent = label;
        this.fillRows(extrasBox, extras);
      } else {
        more.hidden = true;
        this.fillRows(extrasBox, []);
      }

      this.renderEta();
    }

    renderEta() {
      if (!this.main || !this.countryData) return;
      var info = shipInfo(this.data);
      var holidays = this.country === 'DE' ? this.data.holidays : null;
      var span = this.span || this.main.days;
      var from = addTransitDays(info.ship, span[0], holidays);
      var to = addTransitDays(info.ship, span[1], holidays);
      var etaEl = this.querySelector('[data-rf-eta]');
      var etaText = formatRange(from, to, this.lang);
      if (etaEl.textContent !== etaText) etaEl.textContent = etaText;

      var cutoff = this.querySelector('[data-rf-cutoff]');
      if (!cutoff) return;
      var de = this.lang === 'de';
      var html;
      if (info.shipsToday) {
        var mins = Math.max(1, Math.ceil(info.secondsLeft / 60));
        var h = Math.floor(mins / 60);
        var m = mins % 60;
        var t = de
          ? (h ? h + ' Std ' : '') + m + ' Min'
          : (h ? h + 'h ' : '') + m + 'm';
        html = de
          ? 'Bestell in <strong>' + t + '</strong>, dann geht dein Paket heute raus'
          : 'Order within <strong>' + t + '</strong> and it ships today';
      } else {
        var tomorrow = iso(addDays(info.today, 1)) === iso(info.ship);
        var day = tomorrow ? (de ? 'morgen' : 'tomorrow') : (de ? 'am ' : 'on ') + WEEKDAYS_LONG[this.lang][info.ship.getUTCDay()];
        html = de
          ? 'Bestellst du jetzt, geht dein Paket <strong>' + day + '</strong> raus'
          : 'Order now and it ships <strong>' + day + '</strong>';
      }
      if (cutoff.innerHTML !== html) cutoff.innerHTML = html;
    }

    openLocalization() {
      /* Sheet from snippets/rf-lang-switch.liquid: opens right where the shopper is, no scrolling. */
      if (window.rfLangSheet && window.rfLangSheet.open()) return;
      /* RocketFuel language / country switcher (snippets/rf-lang-switch.liquid): the visible
         one with a country list, header first. Opens it, unfolds "Country & currency"
         and focuses the search field. */
      var switchers = Array.prototype.filter.call(document.querySelectorAll('details[data-rf-lang]'), function (d) {
        return d.offsetParent !== null && d.querySelector('.rf-lang__country');
      });
      var rfLang = switchers.filter(function (d) { return d.closest('#header-group, header, .header-section'); })[0] || switchers[0];
      if (rfLang) {
        var inHeader = !!rfLang.closest('#header-group, header, .header-section');
        if (inHeader) window.scrollTo({ top: 0, behavior: 'smooth' });
        else rfLang.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () {
          rfLang.open = true;
          var country = rfLang.querySelector('.rf-lang__country');
          if (country) country.open = true;
          var search = rfLang.querySelector('[data-rf-country-search]');
          if (search) { try { search.focus({ preventScroll: true }); } catch (e) { search.focus(); } }
        }, 350);
        return;
      }
      var desktop = document.querySelector('dropdown-localization-component .dropdown-localization__button');
      if (desktop && desktop.offsetParent !== null) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () {
          if (desktop.getAttribute('aria-expanded') !== 'true') desktop.click();
          desktop.focus();
        }, 350);
        return;
      }
      var menu = document.querySelector('header-drawer summary.header__icon--menu');
      if (menu) {
        var details = menu.closest('details');
        if (details && !details.open) menu.click();
        setTimeout(function () {
          var loc = document.getElementById('HeaderDrawer-localization');
          if (loc) loc.click();
        }, 400);
        return;
      }
      var footer = document.querySelector('footer localization-form-component, footer [class*="localization"]');
      if (footer) footer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  customElements.define('rf-shipping', RfShipping);
})();

